import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	requestCode: {
		hasBeenSent: false,
		isBeingSent: false,
		error: undefined
	},
	resetPassword: {
		isResetting: false,
		hasBeenReset: false,
		error: undefined
	},
	username: undefined
};

export const forgottenPasswordSlice = createSlice({
	name: 'forgottenPassword',
	initialState,
	reducers: {
		requestResetCode: (state, action) => {
			state.requestCode.isBeingSent = true;
			state.username = action.payload.username;
		},
		requestResetCodeCompleted: (state) => {
			state.requestCode.isBeingSent = false;
			state.requestCode.hasBeenSent = true;
			state.requestCode.error = undefined;
		},
		requestResetCodeFailed: (state, action) => {
			state.requestCode.isBeingSent = false;
			state.requestCode.hasBeenSent = false;
			state.requestCode.error = action.payload.message;
		},
		resetUserPassword: (state) => {
			state.resetPassword.isResetting = true;
		},
		resetUserPasswordCompleted: (state) => {
			state.resetPassword.hasBeenReset = true;
			state.resetPassword.isResetting = false;
			state.resetPassword.error = undefined;
		},
		resetUserPasswordFailed: (state, action) => {
			state.resetPassword.hasBeenReset = false;
			state.resetPassword.isResetting = false;
			state.resetPassword.error = action.payload.message;
		}
	}
});

export const {
	requestResetCode,
	requestResetCodeCompleted,
	requestResetCodeFailed,
	resetUserPassword,
	resetUserPasswordCompleted,
	resetUserPasswordFailed
} = forgottenPasswordSlice.actions;

export default forgottenPasswordSlice.reducer;
